<template>
    <div class="events-list">
        <table>
            <thead>
                <tr>
                    <th>
                        #
                    </th>
                    <th>
                        Назва
                    </th>
                    <th>
                        Час початку
                    </th>
                    <th>
                        Час закінчення
                    </th>
                    <th>
                        Дія
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(e, index) in events" :key="index">
                    <td>
                        {{index + 1}}
                    </td>
                    <td>
                        {{e.name}}
                    </td>
                    <td>
                        {{e.start}}
                    </td>
                    <td>
                        {{e.end}}
                    </td>
                    <td>
                        <button type="button" class="copy" @click="copyEventRef(e.id)">Копіювати посилання</button>
                        <button type="button" class="remove" @click="removeEvent(e.id)">Видалити</button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    data : () => ({
        events : [],
        publicPath: process.env.BASE_URL
    }),
    mounted(){
        axios.interceptors.request.use((config) => {
            var token = sessionStorage.getItem('access_token');
            config.headers["Authorization"] = `Bearer ${token}`;
            return config;
        });

        axios.get(location.protocol + '/api/Admin/GetEvents')
        .then(response => {
            this.events = response.data;            
        })
    },
    methods : {
        removeEvent(id){
            let userTrust = confirm("Ви впевнені що хочете видалити подію " + id);

            if(userTrust){
                axios.interceptors.request.use((config) => {
                    var token = sessionStorage.getItem('access_token');
                    config.headers["Authorization"] = `Bearer ${token}`;
                    return config;
                });

                axios.delete(location.protocol + '/api/Admin/RemoveEvent/' + id)
                .then(response => {
                    console.log(response);
                    let eventForDel = this.events.filter(eObj => {
                        return eObj.id == id;
                    });

                    let index = this.events.indexOf(eventForDel);
                    this.events.splice(index, 1);
                });
            }
        },
        copyEventRef(id){
            let copyText = window.location.protocol + window.location.host + '/event/' + id;
            navigator.clipboard.writeText(copyText);
        }
    }
}
</script>

<style lang="scss">
@import '../../../assets/style/table.scss';

.events-list{
    padding: 40px 60px;
}
</style>